import React from "react";

const X: React.FC = () => (
<svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M15.7721 1.62964H18.6597L12.3512 8.83987L19.7727 18.6514H13.9617L9.41037 12.7007L4.2026 18.6514H1.31327L8.06086 10.9392L0.941406 1.62964H6.89989L11.0139 7.06874L15.7721 1.62964ZM14.7587 16.923H16.3587L6.03047 3.26722H4.31346L14.7587 16.923Z" fill="#999999"/>
</svg>
);

export default X;
